import React from "react";
import { connect } from "react-redux";

import { NavContainer, NavItem } from "./components";
import Login from "./Login";
import Cart from "./Cart";
import Currency from "./Currency";
import Destinations, { ButtonLink } from "./Destination";

class NavBar extends React.Component {
  render() {
    const { user } = this.props;
    return (
      <NavContainer>
        {!user.logged && (
          <NavItem dropdown>
            <ButtonLink href="/pro-center" navbar>
              For Partners
            </ButtonLink>
          </NavItem>
        )}
        <NavItem dropdown>
          <Destinations destinations={this.props.destinations} />
        </NavItem>
        <NavItem dropdown>
          <Currency {...this.props.currency} />
        </NavItem>
        <NavItem dropdown>
          <Cart cart={this.props.cart} />
        </NavItem>
        <NavItem dropdown>
          <Login {...this.props.user} />
        </NavItem>
      </NavContainer>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.user,
    currency: state.currency,
    cart: state.cart,
    destinations: state.destinations
  };
};
export default connect(mapStateToProps)(NavBar);
